var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #2b5748;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.14,
    cy: 14.82,
    r: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.89,14.82c-.05-.08-.13-.22-.13-.22-1.13-1.81-4.23-6.03-9.64-6-5.34.03-8.34,4.14-9.57,6,0,0-.09.13-.14.22.06.09.14.22.14.22,1.23,1.86,4.23,5.97,9.57,6,5.41.03,8.51-4.19,9.64-6,0,0,.07-.12.13-.22Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.17,
    y1: 24.55,
    x2: 24.27,
    y2: 5.45
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.6801b43e8aae085fa0c342f523d78623.svg";
export { ForwardRef as ReactComponent };